<!-- Per default our tables in AVANO are wrapped within a panel -->
<avano-panel [headerIcon]="tableConfiguration.headerIcon" [headerText]="headerText ? headerText : tableConfiguration.headerText" [noPadding]="true" [headerSubheading]="tableConfiguration.headerTextDescription" [isCollapsable]="tableConfiguration.tableSettings?.tableCollapsable" [collapsed]="tableCollapsed">
  <ng-template avanoTemplate="areaactions">
    <i
      *ngIf="tableConfiguration.tableSettings?.exportEnabled"
      class="icon-content-download"
      [title]="tableTranslationKeys.DefaultButtons.Export | translate"
      (click)="exportFunction()"
    ></i>
    <i
      *ngIf="tableConfiguration.tableSettings?.refreshEnabled"
      class="icon-content-refresh"
      [title]="tableTranslationKeys.DefaultButtons.Refresh | translate"
      (click)="refreshFunction()"
    ></i>
    <i
      *ngIf="tableConfiguration.tableSettings?.settingsEnabled"
      class="icon-content-settings"
      #settingsIcon
      [title]="tableTranslationKeys.DefaultButtons.Settings | translate"
      (click)="openConfiguration($event, settingsIcon)"
    ></i>
  </ng-template>

  <ng-template avanoTemplate="contentactions">
    <ng-template [ngTemplateOutlet]="panelTemplates?.panelContentActions"></ng-template>
  </ng-template>

  <ng-content></ng-content>

</avano-panel>

<avano-popover
    *ngIf="tableConfiguration.tableSettings?.settingsEnabled"
    #tableSettings
    [styleClass]="'avano-table-settings'"
    [childrenSeparators]="false"
  >
  <avano-table-settings
    [showRowsPerPageSettings]="tableConfiguration.withPagination"
    [rowsPerPageSelection]="rowsPerPageOptions"
    [(rowsPerPage)]="rowsPerPage"
    (resetTableTriggered)="resetTableSettings()"
    [columnConfigurations]="allColumnsConfigurations"
    (columnVisibilityTriggered)="changeColumnVisibility($event)"
  ></avano-table-settings>
</avano-popover>
